import { fetchOrganization } from 'api/portal';
import { useEffect } from 'react';

export function useFetchOrganizationAdmin({ orgId, onSuccess = () => {}, onFailure = () => {} }) {
  useEffect(() => {
    fetchOrganization(orgId)
      .then((response) => {
        const { data } = response;
        onSuccess(data);
      })
      .catch(() => {
        onFailure();
      });
  }, []);
}
